export default "__VITE_ASSET__Bq53OCav__"